import { InjectionToken } from '@angular/core';
import { ServiceStorePort } from '../ports/service-store.port';

export const SERVICE_STORE = new InjectionToken<ServiceStorePort>('SERVICE_STORE');